export default {
  state: {
    timeHorizonIntervals: [],
  },

  mutations: {
    setIntervals(state, data) {
      data.forEach((element) => {
        state.timeHorizonIntervals.push(element)
      })
    },
  },

  actions: {
    getTimeHorizonIntervals({ commit }, data) {
      if (data == null) {
        return
      }
      data[0].id = 1
      data[1].id = 2
      data[2].id = 4
      data[3].id = 8
      if (data.filter((el) => el.id === 0).length === 0) {
        data.push({ from: null, to: null, id: 0 })
      }
      commit('setIntervals', data)
    },

    resetTimeHorizonState({ state }) {
      state.timeHorizonIntervals = []
    },
  },

  getters: {
    getTimeHorizonIntervalsList: (state) => state.timeHorizonIntervals,
  },
}
